import React from "react";
import PropTypes from "prop-types";

import DropdownInput from "components/Dropdown/DropdownInput";
import { Translate } from "utils";

import UserDetails from "../UserDetails";

import styles from "./DropdownUserSelect.css";

const { t } = new Translate("DropdownUserSelect");

const DropdownUserSelect = ({ isRequired, value }) => (
  <div className={styles.root}>
    {value && (
      <UserDetails
        title={value.title ? `${value.title} - ${value.company.name}` : value.company.name}
        user={value}
      />
    )}
    {!value && (
      <>
        <div className={styles.title}>
          <label>{t("pointPerson")}</label>
        </div>
        <DropdownInput isRequired={isRequired} />
      </>
    )}
  </div>
);

DropdownUserSelect.propTypes = {
  isRequired: PropTypes.bool,
  value: PropTypes.shape({
    fname: PropTypes.string, // eslint-disable-line
    lname: PropTypes.string, // eslint-disable-line
    deleted: PropTypes.bool,
    profilePictureUrl: PropTypes.string, // eslint-disable-line
    company: PropTypes.shape({
      name: PropTypes.string, // eslint-disable-line
    }),
  }),
};

export default DropdownUserSelect;
